import styled from "styled-components";

export const UserContainer = styled.div`
  margin-top: 14px;
  overflow-y: scroll;
  // padding-top: 14px;
  height: calc(100% - 123px);
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const UserContent = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 12.36px 0px 0px;
  height: 70px;
  border-left: ${({ active }) => active && "4px solid #407bff"};
  background: ${({ active }) => active && "rgba(64, 123, 255, 0.1)"};
  border-radius: 4px;
  cursor: pointer;
  margin: 10px 0px;
  &:hover {
    background: rgba(64, 123, 255, 0.1);
  }
  position: ${(p) => p.position && p.position};
`;

export const ChatSession = styled.div`
  width: 100%;
  background: #f4f4f4;
  ${({ empty }) =>
    empty &&
    `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  `}
`;